/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map


// Added By MLVeda
class GlaceModal extends HTMLElement {
  constructor() {
    super();
    this.handleUnderstood = this.handleUnderstood.bind(this);
    this.handleClearCart = this.handleClearCart.bind(this);
  }

  connectedCallback() {
    this.btnUnderstood = this.querySelector('.btn-understood');
    this.btnClearCart = this.querySelector('.btn-clear-cart');

    this.btnUnderstood?.addEventListener('click', this.handleUnderstood);
    this.btnClearCart?.addEventListener('click', this.handleClearCart);
  }

  disconnectedCallback() {
    this.btnUnderstood?.removeEventListener('click', this.handleUnderstood);
    this.btnClearCart?.removeEventListener('click', this.handleClearCart);
  }

  open() {
    this.classList.add('active');
  }

  close() {
    this.classList.remove('active');
  }

  handleUnderstood() {
    this.close();
  }

  async handleClearCart() {
    if (!this.btnClearCart) return;

    try {
      // ✅ SHOW LOADER
      this.btnClearCart.classList.add('loading');

      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      window.location.reload();

    } catch (error) {
      console.error('Error clearing cart:', error);

      // ❌ remove loader if error
      this.btnClearCart.classList.remove('loading');
    }
  }
}

if (!customElements.get('glace-modal')) {
  customElements.define('glace-modal', GlaceModal);
}

class ValidateCart extends HTMLElement {
  connectedCallback() {
    this.handleCartValidation();
  }

  async handleCartValidation() {
    try {
      const script = this.querySelector('script[type="application/json"]');
      if (!script) return;

      let updates;
      try {
        updates = JSON.parse(script.textContent.trim());
      } catch (err) {
        console.error('Invalid JSON inside <validate-cart>', err);
        return;
      }

      if (!updates || !Object.keys(updates).length) return;
      console.log(updates)
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      // Optional event trigger
      document.dispatchEvent(new CustomEvent('cart:updated'));

      // for (const key in updates) {
      //   const cart_item = document.querySelector(`interactive-cart cart-item[key="${key}"]`);

      //   if (cart_item) {
      //    cart_item.remove();
      //   }
      // }
      window.location.reload()
    } catch (error) {
      console.error('ValidateCart error:', error);
    }
  }
}

customElements.define('validate-cart', ValidateCart);


// Added By MLVeda: end